import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import apiClient from '../api/client';
import './Auth.css';

export default function PaypalReturn() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('token');

  const [status, setStatus] = useState('Confirming your payment…');
  const [error, setError] = useState('');
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    if (!orderId) {
      setError('Missing PayPal order reference.');
      return;
    }

    apiClient
      .post('/payments/paypal/capture-order', { orderId })
      .then((res) => {
        const payment = res.data.payment;
        const captureStatus = res.data.capture?.status;

        if (captureStatus === 'COMPLETED') {
          setCompleted(true);

          if (payment?.sourceType === 'course') {
            setStatus(
              'Payment successful! Your course enrolment has been activated.'
            );
          } else {
            setStatus(
              'Payment successful! Your counselling appointment is now marked as paid.'
            );
          }
        } else {
          setStatus(`Payment status: ${captureStatus || 'pending'}.`);
        }
      })
      .catch((err) => {
        setError(
          err.response?.data?.message ||
            'Could not confirm payment.'
        );
      });
  }, [orderId]);

  return (
    <div className="auth-page">
      <div className="card auth-card">
        <h1>PayPal Payment</h1>

        {error ? (
          <div className="alert alert-error">{error}</div>
        ) : (
          <div className="alert alert-success">{status}</div>
        )}

        {completed && (
          <p style={{ fontSize: 14.5, lineHeight: 1.7 }}>
            Your payment documents will be available through your account
            after payment processing is complete.
          </p>
        )}

        <Link to="/dashboard" className="btn btn-primary">
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
